<form [formGroup]="form">

    <h2 i18n="@@step1Header">Maak vrijblijvend je afspraak</h2>

    <div>
        <h3 i18n="@@step1Question1Header">In welk type isolatie ben je geïnteresseerd?</h3>
        <div class="cards"
            style="margin: 0 -13px;">
            <ig-card i18n-title="@@isolationType1"
                title="Spouwmuurisolatie"
                [selected]="form.controls.isolationType1.value"
                (click)="form.controls.isolationType1.setValue(!form.controls.isolationType1.value)"
                [compact]="true">
            </ig-card>
            <ig-card i18n-title="@@isolationType2"
                title="Vloerisolatie"
                [selected]="form.controls.isolationType2.value"
                (click)="form.controls.isolationType2.setValue(!form.controls.isolationType2.value)"
                [compact]="true">
            </ig-card>
            <ig-card i18n-title="@@isolationType3"
                title="Dakisolatie"
                [selected]="form.controls.isolationType3.value"
                (click)="form.controls.isolationType3.setValue(!form.controls.isolationType3.value)"
                [compact]="true">
            </ig-card>
            <ig-card i18n-title="@@isolationType4"
                title="Kruipkelderisolatie"
                [selected]="form.controls.isolationType4.value"
                (click)="form.controls.isolationType4.setValue(!form.controls.isolationType4.value)"
                [compact]="true">
            </ig-card>
            <ig-card i18n-title="@@isolationType5"
                title="Impregneren gevel"
                [selected]="form.controls.isolationType5.value"
                (click)="form.controls.isolationType5.setValue(!form.controls.isolationType5.value)"
                [compact]="true">
            </ig-card>
        </div>
    </div>

    <ig-footer>
        <span></span>
        <ig-button-secondary i18n="@@footerButtonStep3"
            [isDisabled]="!form.valid"
            (click)="onNextButtonClick($event)">invullen contactgegevens</ig-button-secondary>
    </ig-footer>

</form>
